export default __webpack_public_path__ + "static/media/filter-grey-icon.5b64fdda.svg";